/**
 * @engine/vfx - Operator Nodes
 *
 * Math, random, and utility nodes available in any context.
 */

import type { VFXNodeDefinition } from '../../types';
import { dataPort } from '../../types';

/**
 * Operator node definitions.
 */

export const NOISE_NODES: readonly VFXNodeDefinition[] = [

  {
    id: 'vfx.operator.perlin_noise',
    name: 'Perlin Noise',
    category: 'operator',
    contexts: [],
    description: 'Sample perlin noise',
    color: '#795548',
    inputs: [
      dataPort('position', 'Position', 'vec3'),
      dataPort('frequency', 'Frequency', 'float', { defaultValue: 1 }),
      dataPort('octaves', 'Octaves', 'int', { defaultValue: 3, range: { min: 1, max: 8 } }),
    ],
    outputs: [
      dataPort('result', 'Result', 'float'),
    ],
    shader: {
      code: `
        // Fractal Brownian motion: octave sum of simplex noise
        var p = position * frequency;
        var amplitude = 0.5;
        var total = 0.0;
        for (int i = 0; i < octaves; i++)
        {
            total += snoise3D(p) * amplitude;
            p *= 2.0;
            amplitude *= 0.5;
        }
        result = total;
      `,
    },
  },

  {
    id: 'vfx.operator.curl_noise',
    name: 'Curl Noise',
    category: 'operator',
    contexts: [],
    description: 'Sample curl noise (divergence-free)',
    color: '#795548',
    inputs: [
      dataPort('position', 'Position', 'vec3'),
      dataPort('frequency', 'Frequency', 'float', { defaultValue: 1 }),
    ],
    outputs: [
      dataPort('result', 'Result', 'vec3'),
    ],
    shader: {
      code: `result = curlNoise3D(position * frequency);`,
    },
  },
];
